import React from "react";
import { createRoot } from "react-dom/client";
import { MonoTemplate } from "./MonoTemplate";
import type { TemplateAlertHandler } from "../types";

// Handler que monta el template "mono" como un portal en <body>
export const monoTemplateAlert: TemplateAlertHandler = ({ onDismiss, onReload, payload }) => {
  // Asegura una sola alerta a la vez: limpia contenedores previos
  try {
    const prev = document.querySelectorAll('[data-react-checker-version-container]');
    prev.forEach(el => {
      try { el.remove(); } catch {}
    });
    const overlays = document.querySelectorAll('[data-react-checker-version]');
    overlays.forEach(el => {
      try { el.remove(); } catch {}
    });
  } catch {}

  const container = document.createElement("div");
  container.setAttribute("data-react-checker-version-container", "mono");
  document.body.appendChild(container);

  const root = createRoot(container);

  const cleanup = () => {
    try {
      root.unmount();
    } catch {}
    try {
      container.remove();
    } catch {}
  };

  const handleDismiss = () => {
    cleanup();
    onDismiss();
  };
  const handleReload = () => {
    cleanup();
    onReload();
  };

  root.render(
    <MonoTemplate
      {...payload}
      onDismiss={handleDismiss}
      onReload={handleReload}
    />
  );

  // Devolvemos cleanup para que el hook pueda cerrar esta alerta si necesita actualizarla
  return cleanup;
};

export default monoTemplateAlert;
